import { apiRequest } from "./apiClient";

export const spendSupplierConsolidationService = {

  getLatestRecord: async () => {
    try {
      return await apiRequest("/api/supplier-consolidation/latest");
    } catch (error) {
      if (error instanceof Error && error.message === "API Error: 404") {
        return null;
      }

      throw error;
    }
  },

  getAllRecords: async () => {
    return apiRequest(
      "/api/supplier-consolidation"
    );
  },

  getByConversationId: async (conversationId: string) => {
    return apiRequest(
      `/api/supplier-consolidation/conversation/${conversationId}`
    );
  },

  saveSupplierConsolidationRecord: async (payload: any) => {
    return apiRequest(
      "/api/supplier-consolidation",
      {
        method: "POST",
        body: JSON.stringify(payload)
      }
    );
  },
  updateSupplierConsolidationRecord: async (payload: any) => {
    return apiRequest(
      "/api/supplier-consolidation",
      {
        method: "PUT",
        body: JSON.stringify(payload)
      }
    );
  }
};